import React from 'react';

import styles from './PricingPromoCircle.scss';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const PricingPromoCircle = props => {
  return (
    <div className="PricingPromoCircle">
      <ConnectedFormattedMessage id="pricing_page.promo_circle" />
    </div>
  );
};

export default PricingPromoCircle;
